// extracted by mini-css-extract-plugin
module.exports = {"icon":"ClosePage_icon__3lXe9"};